import React, {useEffect, useState} from 'react';
import CitySelector from './CitySelector';
import CityCenters from './CityCenters'; // Import the new component

function PickUpCentersMain(props) {
  const [selectedCity, setSelectedCity] = useState(null);
  const [cities, setCities] = useState(props.citiesServiceCenters??null);
  const [pickupDate, setPickupDate] = useState(props.pickupDate??null);

  const handleCitySelect = (city) => {
    setSelectedCity(city);
  };

  useEffect(() => {
    const GetCitiesServiceCentersAction = async () => {
      const res = await props.GetCitiesServiceCenters();
      setCities(res.payload.citiesServiceCenters);
      setPickupDate(res.payload.pickupDate);
    };
    if(cities==null){
          GetCitiesServiceCentersAction();
    }
  }, []);

  return (
    <div>
      <CitySelector cities={cities} pickupDate={pickupDate}  onSelect={handleCitySelect} />
      {selectedCity && (
        <>
          <CityCenters
            handleSelect={props.handleSelect}
            selectedCenter={props.selectedCenter}
            isVisible={!!selectedCity}
            city={selectedCity?.city}
            serviceCenters={selectedCity?.serviceCenters}
          />
        </>
      )}
    </div>
  );
}

export default PickUpCentersMain;
